import React from 'react';

interface CompanyContactInfoProps {
  formData: any;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
}

export const CompanyContactInfo: React.FC<CompanyContactInfoProps> = ({ formData, handleChange }) => {
  return (
    <div className="form-section">
      <h3>Contact Information</h3>
      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="contact_name">Contact Name</label>
          <input
            type="text"
            id="contact_name"
            name="contact_name"
            value={formData.contact_name}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="contact_role">Contact Role</label>
          <input
            type="text"
            id="contact_role"
            name="contact_role"
            value={formData.contact_role}
            onChange={handleChange}
            placeholder="e.g., CEO, Managing Director"
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="managing_director">Managing Director</label>
          <input
            type="text"
            id="managing_director"
            name="managing_director"
            value={formData.managing_director}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="telephone_number">Phone Number</label>
          <input
            type="tel"
            id="telephone_number"
            name="telephone_number"
            value={formData.telephone_number}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="fax_number">Fax Number</label>
          <input
            type="tel"
            id="fax_number"
            name="fax_number"
            value={formData.fax_number}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="email_address">Email Address</label>
          <input
            type="email"
            id="email_address"
            name="email_address"
            value={formData.email_address}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="support_email">Support Email</label>
          <input
            type="email"
            id="support_email"
            name="support_email"
            value={formData.support_email}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="billing_email">Billing Email</label>
          <input
            type="email"
            id="billing_email"
            name="billing_email"
            value={formData.billing_email}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="website_url">Website</label>
          <input
            type="url"
            id="website_url"
            name="website_url"
            value={formData.website_url}
            onChange={handleChange}
            className="form-control"
          />
        </div>
      </div>
    </div>
  );
};